(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/javascripts/prescript.js');

'use strict';

var _svs, _svs$numbergames, _svs$numbergames2, _svs$numbergames2$fra;
(_svs$numbergames = (_svs = svs).numbergames) !== null && _svs$numbergames !== void 0 ? _svs$numbergames : _svs.numbergames = {};
(_svs$numbergames2$fra = (_svs$numbergames2 = svs.numbergames).fractiongames) !== null && _svs$numbergames2$fra !== void 0 ? _svs$numbergames2$fra : _svs$numbergames2.fractiongames = {};
svs.numbergames.fractiongames.api_calls = {};
svs.numbergames.fractiongames.utils = {};
svs.numbergames.fractiongames.logger = new svs.core.log.Logger('numbergames:fractiongames');

svs.numbergames.fractiongames.redux = {
  thunks: {},
  middlewares: {},
  slices: {
    containers: {}
  }
};

svs.numbergames.fractiongames.contexts = {};
svs.numbergames.fractiongames.components = {
  gamecard: {}
};

 })(window);